import { Image, ImageStyle, StyleProp } from 'react-native';

import { CdnImageName, getImageUrl } from '../../utils/common';

export default function CardDetailImage({
  source,
  style,
}: {
  source: CdnImageName;
  style: StyleProp<ImageStyle>;
}) {
  return (
    <Image
      style={style}
      source={{
        uri: getImageUrl(source),
      }}
    />
  );
}
